<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="基础数据" name="base">
      <base-data :sdata="sdata"></base-data>
    </el-tab-pane>
    <el-tab-pane label="存储数据" name="save">
      <save-data :sdata="sdata"></save-data>
    </el-tab-pane>
   <!-- <el-tab-pane label="工厂数据" name="factory" v-if="sdata.mtrlFactorys">
      <factory-data  :sdata="sdata"></factory-data>
    </el-tab-pane> -->
    <!-- <el-tab-pane label="财务数据" name="finance">
      <finance-data :sdata="sdata"></finance-data>
    </el-tab-pane> -->
  </el-tabs>

</template>

<script>
import baseData from './components/detail/base.vue';
import saveData from './components/detail/save.vue';
import financeData from './components/detail/finance.vue';
import factoryData from './components/detail/factory.vue';
export default{
  components:{baseData,saveData,factoryData,financeData},
  props:{
    sdata:Object
  },
	data(){
		return{
			activeName: 'base'
		}
	}
}
</script>

<style>
</style>
